import Vue from 'vue';
import Vuex from 'vuex';

import login from "../pages/login-forms/login/store";
import register from "../pages/register/store";
import app from "../pages/banner/store";
import settings from "../pages/usersStakeholders/store";
import surveys from "../pages/surveys/store";
import company from "../pages/company/store";
import results from "../pages/results/store";
import additionalsettings from "../pages/additionalSettings/store";
import projectsearchengine from "../pages/projectSearchEngine/store";
import reports from "../pages/reports/store";
import KPIsMetrics from "../pages/KPIsMetrics/store";
import supplier from "../pages/supplierMetrics/store";
import admin from "../pages/adminPanel/store";
import auditor from "../pages/auditor/store";
import documents from "../pages/documents/store";
import approvals from "../components/Approval/store";

Vue.use(Vuex);

export const storeOptions = {
    modules: {
      login,
      app,
      settings,
      surveys,
      company,
      results,
      additionalsettings,
      projectsearchengine,
      reports,
      KPIsMetrics,
      register,
      supplier,
      admin,
      auditor,
      documents,
      approvals,
    },
};

export default new Vuex.Store(storeOptions);